/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsBroom: {
  name: 'broom';
  data: string;
} = {
  name: 'broom',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M20.707 4.707a1 1 0 0 0-1.414-1.414l-5.891 5.89a3.667 3.667 0 0 0-3.73.093L3.47 13.152a1 1 0 0 0-.177 1.555l2.5 2.5 3.5 3.5a1 1 0 0 0 1.555-.177l3.876-6.201a3.667 3.667 0 0 0 .092-3.731l5.891-5.89ZM7.914 16.5l.793-.793a1 1 0 1 0-1.414-1.414l-.793.793-.904-.904 3.182-1.99 3.03 3.03-1.99 3.182L7.914 16.5Zm4.879-5.293a1.667 1.667 0 0 0-2.062-.235l-.212.133 2.376 2.376.133-.212a1.667 1.667 0 0 0-.235-2.062Z" fill="currentColor"/></svg>`,
};
